import Component from "../../lib/component";

export const InventoryHeadConfig = {
    componentTypeKey: 'InventoryHead',
    baseHtmlClass: 'inventory__head',
    selector: '.inventory__head',
};

export class InventoryHead extends Component {

    static createElement() {
        return Component.createElement(InventoryHeadConfig.baseHtmlClass);
    }

    constructor(id_or_element, inventory) {
        super({
            element: id_or_element,
            config: InventoryHeadConfig
        });

        this.inventory = inventory;
        this.render();
    }

}
